import { render, staticRenderFns } from "./SoftwarePage.vue?vue&type=template&id=84778904&scoped=true"
import script from "./SoftwarePage.vue?vue&type=script&lang=js"
export * from "./SoftwarePage.vue?vue&type=script&lang=js"
import style0 from "./SoftwarePage.vue?vue&type=style&index=0&id=84778904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84778904",
  null
  
)

export default component.exports